import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
	selector: 'app-modal-tooltip',
	templateUrl: './modal-tooltip.component.html',
	styleUrls: ['./modal-tooltip.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ModalTooltipComponent implements OnInit {
	constructor(public activeModal: NgbActiveModal) {}

	ngOnInit(): void {}
	close() {
		this.activeModal.close()
	}
}
